import type { Track } from 'types/track'

/**
 * Normalizes an aggregated (MultiDISCO) search track to the shape the app
 * expects. Works for both the legacy aggregated endpoints (which carry
 * `origin.source_library` and no `url`) and v2 search hits (which carry a
 * `source` catalog object and a business `/api/track/` url the requesting
 * business is not allowed to call).
 *
 * The returned `url` always points at the aggregated-search track endpoint,
 * which is the only track-detail endpoint permitted for cross-library tracks.
 */
export const serializeAggregatedTrack = (track: Track) => {
  const source = (
    track as Track & {
      source?: { id: number; name?: string; url?: string }
    }
  ).source

  const sourceLibrary =
    track.origin?.source_library ??
    (source
      ? {
          id: source.id,
          name: source.name ?? '',
          url: source.url ?? '',
          contacts: [],
        }
      : undefined)

  return {
    ...track,
    artwork: track.artwork,
    // @ts-expect-error artwork_sizes is not defined in the type
    artwork_sizes: track.artwork?.artwork_sizes,
    internal_data: {
      is_aggregated_search_track: true,
    },
    ...(sourceLibrary && {
      origin: {
        contacts: [],
        ...track.origin,
        source_library: sourceLibrary,
      },
    }),
    url: `/api/aggregated_search/client_library/${
      sourceLibrary?.id ?? ''
    }/track/${track.id}/`,
    read_only: true,
  }
}

export const serializeAggregatedSearchResults = (results: Track[]): Track[] =>
  results.map(serializeAggregatedTrack)
